import { ILocalizationItem } from "@multiweb/types/contracts/localizations";

export interface ILocalizationManager {
    /**
     * Načte požadované lokalizace. Kombinuje několik zdrojů a používá ty nejrychlejší.
     * @param language Kód jazyka lokalizací (např. 'EN' nebo 'CZ')
     * @param locKeys Lokalizační klíče k načtení
     */
    getLocalizations(language: string, locKeys: readonly string[]): Promise<readonly ILocalizationItem[]> ;
}
